export default __webpack_public_path__ + "static/matthias-b9c7e3a672096e1033d3ec137febdb55.png";